import { Phone } from 'lucide-react';

export function InstructorContact() {
  return (
    <div className="mx-auto mt-6 max-w-sm rounded-2xl border border-brand-200 bg-brand-50/50 px-5 py-3.5 text-center">
      <p className="text-sm text-slate-700">
        Have questions? Contact Abraham directly at{' '}
        <a
          href="tel:+19498385889"
          className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap font-bold text-brand-700 underline decoration-brand-400 decoration-2 underline-offset-2 transition-colors hover:text-brand-800"
        >
          <Phone className="size-3.5" aria-hidden="true" />
          (949) 838-5889
        </a>
      </p>
    </div>
  );
}